import * as api from 'App/api/articles'
import * as organizationsApi from 'App/api/organizations'
import {
  fetchCampaignImages,
  fetchOrganizationImages
} from 'App/api/imageGallery'
import { getUseImageBank } from 'App/modules/organizationSettings/selectors'
import { currentBoard } from 'App/modules/boardView/selectors'
import { USERS_FETCH_TYPES } from 'App/modules/organizations'
import ORGANIZATION_IMAGE_CATEGORIES from 'common/constants/organizationImageCategories'
import isNull from 'lodash/isNull'
import get from 'lodash/get'
import debounce from 'lodash/debounce'

const FETCH_ARTICLE_SUCCESS = 'articles/FETCH_ARTICLE_SUCCESS'
const CREATE_ARTICLE_SUCCESS = 'articles/CREATE_ARTICLE_SUCCESS'
const UPDATE_ARTICLE = 'articles/UPDATE_ARTICLE'
const UPDATE_ARTICLE_SUCCESS = 'articles/UPDATE_ARTICLE_SUCCESS'
export const PUBLISH_ARTICLE_SUCCESS = 'articles/PUBLISH_ARTICLE_SUCCESS'
export const REVERT_CHANGES_SUCCESS = 'articles/REVERT_CHANGES_SUCCESS'
const FETCH_ARTICLES_AUTHORS_SUCCESS = 'articles/FETCH_ARTICLES_AUTHORS_SUCCESS'
const FETCH_IMAGES_SUCCESS = 'articles/FETCH_IMAGES_SUCCESS'
const CREATE_ARTICLE_IMAGE = 'articles/CREATE_ARTICLE_IMAGE'

export const ARTICLE_STATUSES = {
  draft: 1,
  published: 2
}

export const ARTICLE_HEADER_POSITIONS = {
  top: 1,
  bottom: 2
}

const UPDATE_INTERVAL = 3000

export function fetchArticle(articleId) {
  return (dispatch, getState) => {
    const authorizationParams =  getAuthorizationParams(getState())

    return api.fetchArticle({ articleId, authorizationParams })
      .then(article => {
        dispatch({
          type: FETCH_ARTICLE_SUCCESS,
          articleId,
          article
        })

        return article
      })
  }
}

export function publish(articleId, data) {
  return (dispatch, getState) =>  {
    const authorizationParams =  getAuthorizationParams(getState())

    return api.publishArticle({ articleId, data, authorizationParams })
      .then((article) => {
        debouncedUpdate.cancel()

        dispatch({
          type: PUBLISH_ARTICLE_SUCCESS,
          articleId,
          article,
          trackingParams: {
            content_item_id: article.content_item_id,
            article_id: article.article_id,
            article_title: article.title
          }
        })

        return article
      })
  }
}

export function revertChanges(articleId) {
  return (dispatch, getState) =>  {
    const authorizationParams =  getAuthorizationParams(getState())

    api.revertArticle({
      articleId,
      toStatus: ARTICLE_STATUSES.published,
      authorizationParams
    })
      .then((article) => {
        debouncedUpdate.cancel()

        dispatch({
          type: REVERT_CHANGES_SUCCESS,
          articleId,
          article,
          trackingParams: {
            content_item_id: article.content_item_id,
            article_id: article.article_id,
            article_title: article.title
          }
        })
      })
  }
}

export function createArticle() {
  return (dispatch, getState) => {
    const authorizationParams =  getAuthorizationParams(getState())

    return api.createArticle({ authorizationParams })
      .then(article => {
        dispatch({
          type: CREATE_ARTICLE_SUCCESS,
          articleId: article.article_id,
          article
        })

        return article.article_id
      })
  }
}

export function updateArticle(articleId, data) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_ARTICLE,
      articleId
    })

    const authorizationParams =  getAuthorizationParams(getState())

    return api.updateArticle({ articleId, data, authorizationParams })
      .then(article => {
        debouncedUpdate.cancel()

        dispatch({
          type: UPDATE_ARTICLE_SUCCESS,
          articleId,
          article
        })

        return article
      })
  }
}

/***** enables autoSaving *****/
function dispatchUpdate(articleId, data, dispatch, getState) {
  updateArticle(articleId, data)(dispatch, getState)
}

const debouncedUpdate = debounce(dispatchUpdate, UPDATE_INTERVAL)
//*****************************/

export function articleDataChanged(articleId, data) {
  return (dispatch, getState) => {
    debouncedUpdate(articleId, data, dispatch, getState)
  }
}

export function fetchArticleAuthors() {
  return (dispatch, getState) => {
    const organizationId = getState().user.organization.id

    organizationsApi.fetchOrganizationUsers(organizationId, {
      fetch_type: USERS_FETCH_TYPES.userOrganization,
      skip_pagination: true,
      active_filters: {
        active: true
      }
    })
      .then(data => {
        return dispatch({
            type: FETCH_ARTICLES_AUTHORS_SUCCESS,
            articleAuthors: data
        })
      })
  }
}

export function fetchGalleryImages() {
  return (dispatch, getState) => {
    fetchImageGallery()(dispatch, getState)
      .then(galleryImages => {
        dispatch({
          type: FETCH_IMAGES_SUCCESS,
          galleryImages
        })
      })
  }
}

function fetchImageGallery() {
  return (dispatch, getState) => {
    const currentState = getState()
    const organizationId = currentBoard(currentState).organization_id || currentState.user.organization.id
    const useImageBank = getUseImageBank(currentState, 'banners')

    if (useImageBank && organizationId) {
      return fetchOrganizationImages(ORGANIZATION_IMAGE_CATEGORIES.images, organizationId)
    } else {
      return fetchCampaignImages()
    }
  }
}

export function createImage(articleId, image) {
  return (dispatch, getState) => {
    const authorizationParams =  getAuthorizationParams(getState())

    return api.createImage({ articleId, image, authorizationParams })
      .then(image => {
        dispatch({
          type: CREATE_ARTICLE_IMAGE,
          articleId,
          image
        })

        return image
      })
  }
}

function getAuthorizationParams(state) {
  return {
    board_id: get(state.boardView, 'currentBoard.id')
  }
}

const initialState = {
  article: {
    // article_id
    // status
    // creator
    // title
    // author
    // published_at
    // read_time
    // body
    // has_unpublished_changes
    // published_data
    // images
    //bio_settings
    // header_settings
  },
  isSaving: false,
  authors: [],
  galleryImages: [],
  isEnabled: false
}

export function prepareInitialState({ features: { articles } }) {
  if (isNull(articles)) {
    return initialState
  }

  return {
    ...initialState,
    isEnabled: articles
  }
}

function article(state = initialState, action) {
  switch(action.type) {
    default:
      return state
    }
  }

export default function articles(state = initialState, action) {
  switch(action.type) {
    case FETCH_ARTICLE_SUCCESS:
    case PUBLISH_ARTICLE_SUCCESS:
    case REVERT_CHANGES_SUCCESS:
    case CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        article: action.article,
      }
   case CREATE_ARTICLE_IMAGE:
    return {
      ...state,
      article: {
        ...state.article,
        images: [ action.image, ...state.article.images ]
      }
    }
  case UPDATE_ARTICLE:
    return {
      ...state,
      isSaving: true
    }
  case UPDATE_ARTICLE_SUCCESS:
    return {
      ...state,
      article: action.article,
      isSaving: false
    }
    case FETCH_ARTICLES_AUTHORS_SUCCESS: {
      const articleCurrentAuthor = state.article.author.value
      let articleAuthors = action.articleAuthors

      if (!articleAuthors.user_ids.includes(articleCurrentAuthor)) {
        articleAuthors = {
          user_ids: [...articleAuthors.user_ids, articleCurrentAuthor],
          users: {
            ...articleAuthors.users,
            [articleCurrentAuthor]: state.article.author_user
          }
        }
      }

      const authors = articleAuthors.user_ids.map(id => {
        const currentAuthor = articleAuthors.users[id]

        return {
          id: currentAuthor.id,
          label: currentAuthor.name,
          name: currentAuthor.name,
          image: currentAuthor.image || '',
          bio_settings: currentAuthor.bio_settings,
          twitter: currentAuthor.twitter,
          linkedin: currentAuthor.linkedin
        }
      })

      return {
        ...state,
        authors
      }
    }
    case FETCH_IMAGES_SUCCESS: {
      return {
        ...state,
        galleryImages: action.galleryImages
      }
    }
    default:
      return state
  }
}